import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Apollo} from 'apollo-angular';
import { IContractor } from '../../../models/contractor.interface';
import { ListContractorsQuery, ListContractorsZipQuery, GetContractorByIdQuery, ListContractorsFilterQuery } from '../../../graphql/queries/contractor.query';
import { GetContractorReviewsQuery } from '../../../graphql/queries/contractorreview.query';
import { ContractorApiService } from '../contractor-api.service';

@Injectable({
  providedIn: 'root'
})
export class ContractorGqlService implements ContractorApiService {
  constructor(private apollo: Apollo) {}

  public getContractorList(): Observable<IContractor[]> {
    //console.log(`ContractorGql.getContractorList()`);
    return this.apollo
      .watchQuery({
        query: ListContractorsQuery
      })
      .valueChanges.pipe(
        map(result => result.data['contactContractors'] as IContractor[]),
        take(1)
      );
  }

  public getContractorListZip(
    zipC: string,
    programtypes: string
  ): Observable<IContractor[]> {
    //console.log(`ContractorGql.getContractorListZip(${zipC})`);
    return this.apollo
      .watchQuery({
        query: ListContractorsZipQuery,
        variables: {
          zip: zipC,
          programtypes: programtypes
        }
      })
      .valueChanges.pipe(
        map(
          result =>
            result.data['contactContractorsProximityZIP'] as IContractor[]
        ),
        take(1)
      );
  }

  public getContractorListFilter(
    filter: string,
    programtypes: string
  ): Observable<IContractor[]> {
    //console.log(`ContractorGql.getContractorListFilter(${filter})`);
    return this.apollo
      .watchQuery({
        query: ListContractorsFilterQuery,
        variables: {
          filter: filter,
          programtypes: programtypes
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contactContractorsFilter'] as IContractor[]),
        take(1)
      );
  }

  public getContractor(
    id: string,
    resetCache: boolean
  ): Observable<IContractor> {
    //console.log(`ContractorGql.getContractor()`);
    return this.apollo
      .watchQuery({
        query: GetContractorByIdQuery,
        variables: {
          id: id,
          resetCache: resetCache
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contact'] as IContractor),
        take(1)
      );
  }

  public updateContractor(contractor: IContractor): Observable<any> {
    return null;
  }

  public getContractorReviews(id: string): Observable<any> {
    return this.apollo
      .watchQuery({
        query: GetContractorReviewsQuery,
        variables: {
          contractorid: id
        }
      })
      .valueChanges.pipe(
        map(result => result.data['contractorReviews'] as IContractor[]),
        take(1)
      );
  }
}
